import { render, staticRenderFns } from "./ActiviteManagement.vue?vue&type=template&id=e95e845e&scoped=true"
import script from "./ActiviteManagement.vue?vue&type=script&lang=js"
export * from "./ActiviteManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e95e845e",
  null
  
)

export default component.exports